module.exports = __webpack_public_path__ + "static/carbon.25c19b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/carbon.png
// module id = 842
// module chunks = 73261030922168